module.exports = __webpack_public_path__ + "img/green_logo_bg.13d15fce.png";